/** Етап, до якого дійшла розробка. Нумерація — за docs/PLAN.md. */
export const CURRENT_STAGE = 7
export const CURRENT_STAGE_LABEL = '7'
